import apiClient from "lib/axios";
import type { Document, DocumentUploadPayload } from "types/document.types";

export const documentsService = {
  getMyDocuments: async (): Promise<Document[]> => {
    const { data } = await apiClient.get<Document[]>("/student/documents");
    return data;
  },

  uploadDocument: async (payload: DocumentUploadPayload): Promise<Document> => {
    const formData = new FormData();
    formData.append("type", payload.type);
    formData.append("file", payload.file);

    const { data } = await apiClient.post<Document>(
      "/student/documents",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return data;
  },

  deleteDocument: async (id: number): Promise<void> => {
    await apiClient.delete(`/student/documents/${id}`);
  },
};
